module.exports = __webpack_public_path__ + "static/media/电机驱动模块.b740cf07.png";